import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsx("g", {
        clipPath: "url(#tym9zsa0v__clip0_2_88167)",
        children: _jsxs("g", {
          clipPath: "url(#avrpjjqf1__clip1_2_88167)",
          children: [_jsx("path", {
            d: "M-1.11659 -0.0667038V20.0666H35.9297V-0.0667038H-1.11659Z",
            fill: "#001489"
          }), _jsx("path", {
            d: "M-1.11659 -0.0667038V9.99996H35.9297V-0.0667038H-1.11659Z",
            fill: "#E03C31"
          }), _jsx("path", {
            d: "M-1.11659 -0.0667038L17.4056 9.99996L-1.11659 20.0666V-0.0667038ZM17.4056 9.99996H35.9278Z",
            fill: "black"
          }), _jsx("path", {
            d: "M-1.11659 -0.0667038L17.4056 9.99996L-1.11659 20.0666",
            fill: "black"
          }), _jsx("path", {
            d: "M1.16877 22.8575L-3.4016 17.2742L9.98544 10.0001L-3.4016 2.72605L1.16877 -2.85728L19.691 7.20753L24.828 10.0001L19.691 12.7927L1.16877 22.8575Z",
            fill: "#FFB81C"
          }), _jsx("path", {
            d: "M1.16837 22.8575L-2.48718 18.3927L12.9517 10.0001L-2.48718 1.60753L1.16837 -2.85728L18.6535 6.64457H35.9295V13.3557H18.6535L1.16837 22.8575Z",
            fill: "white"
          }), _jsx("path", {
            d: "M0.253556 21.7408L-2.48718 18.3927L12.9517 10.0001L-2.48718 1.60746L0.253556 -1.74068L18.1554 7.98709H35.9295V12.013H18.1554L0.253556 21.7408Z",
            fill: "#007749"
          })]
        })
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "#152361"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "tym9zsa0v__clip0_2_88167",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "avrpjjqf1__clip1_2_88167",
          children: _jsx("rect", {
            width: "35.5556",
            height: "20",
            fill: "white",
            transform: "translate(-1)"
          })
        })]
      })]
    }))
  });
};
export default Component;
